export default {
  labels: {
    signed_by: 'Underskrevet af {{name}} den {{date}}',
    signed_by_no_date: 'Underskrevet af {{name}}',
  },
  buttons: {
    retry: 'Prøv igen',
  },
  errors: {
    load_failed: 'Kontrakten kunne ikke indlæses. Tjek din forbindelse, og prøv igen.',
  },
};
